import { InfoIcon } from 'lucide-react';

import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@/components/ui/item';
import { Badge } from '@/components/ui/badge';
import { roleOptionsDict } from 'src/components/User';

const PermissionPopover = () => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline">
          <InfoIcon /> About roles
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-md p-2">
        <Item className="p-2">
          <ItemContent>
            <ItemTitle className="font-semibold">Organization roles</ItemTitle>
            <ItemDescription className="text-xs line-clamp-none text-wrap">
              Each role defines what a member can do within your organization. <br />
              <i>Product-level permissions are managed separately within each product.</i>
            </ItemDescription>
          </ItemContent>
        </Item>
        <Item className="p-2 gap-3">
          <ItemMedia variant="default" className="w-18">
            <Badge variant={roleOptionsDict.owner.badgeVariant}>{roleOptionsDict.owner.label}</Badge>
          </ItemMedia>
          <ItemContent>
            <ItemDescription className="text-xs line-clamp-none text-wrap">
              <strong>Full access.</strong> Manages billing, organization settings, members, and products. Automatically
              added to all products as a Manager.
            </ItemDescription>
          </ItemContent>
        </Item>
        <Item className="p-2 gap-3">
          <ItemMedia variant="default" className="w-18">
            <Badge variant={roleOptionsDict.admin.badgeVariant}>{roleOptionsDict.admin.label}</Badge>
          </ItemMedia>
          <ItemContent>
            <ItemDescription className="text-xs line-clamp-none text-wrap">
              <strong>Org management.</strong> Manages organization settings and members. Can create products.
            </ItemDescription>
          </ItemContent>
        </Item>
        <Item className="p-2 gap-3">
          <ItemMedia variant="default" className="w-18">
            <Badge variant={roleOptionsDict.user.badgeVariant}>{roleOptionsDict.user.label}</Badge>
          </ItemMedia>
          <ItemContent>
            <ItemDescription className="text-xs line-clamp-none text-wrap">
              <strong>Read-only.</strong> Can only access products they&apos;ve been assigned to. Permissions are set at
              the product level.
            </ItemDescription>
          </ItemContent>
        </Item>
      </PopoverContent>
    </Popover>
  );
};

export default PermissionPopover;
